<template>
    <div class="login-form">
        <h1>
            <span v-if="!user">
                Login to 
            </span>
            <span v-else>
                Logout of
            </span>
            <span style="white-space: nowrap">
                McCluskey Logistics App
            </span>
        </h1>
        <div class="form-part" v-if="user">
            <p> 
                You are logged in as: 
                <b>
                    {{ user.email }}
                </b>
            </p>
            <v-button @click="logout">
                Logout
            </v-button>
        </div>
        <div class="form-part" v-else>
            <div>
                <v-input name="email" type="email" @change="credentials.email = $event" :currentValue="credentials.email" placeholder="Email">
                </v-input>
            </div>
            <div>
                <v-input name="password" type="password" @enter="login" @change="credentials.password = $event" :currentValue="credentials.password" placeholder="Password">
                </v-input>
            </div>
            <div>
                <v-input v-if="false" type="checkbox" @change="credentials.remember_me = $event" :currentValue="credentials.remember_me">
                    Remember Me
                </v-input>
            </div>
            <div>
                <external-link :href="reminderLink"><!--"https://mccluskeybucks.com/password/remind">-->
                    Forgot your password?
                </external-link>
                <v-button style="float: right" @click="login">
                    Login
                </v-button>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '../config'
    import jwt_decode from "jwt-decode";
    
    export default {
        data () {
            return {
                credentials: {
                    email: '',
                    password: '',
                    remember_me: false
                },
                replacementPath: '/trips'
            }
        },
        computed: {
            user () {
                return this.$privateReactiveStore.getUser();
            },
            reminderLink() {
                console.log("REMINDER LINK " + config.config.stockbookUrl + "/password/remind");
                return config.config.stockbookUrl + "/password/remind";
            }
        },
        methods: {
            login () {
                if(this.$router.currentRoute.query.redirect) {
                    this.replacementPath = this.$router.currentRoute.query.redirect;
                }

                config.stockbookApi('').post('/auth/login', this.credentials)
                .then(result => {
                    let usrJWT = result.data.token;
                    let decodedUserJWT = jwt_decode(usrJWT);
                    let usr = decodedUserJWT.data;

                    usr['id'] = decodedUserJWT.sub;
                    
                    localStorage.setItem('authToken', usrJWT);
                    this.$privateReactiveStore.setUser(usr);
                    this.$router.push({path: this.replacementPath});
                })
                .catch(err => {
                    if (err.response.status >= 400) {
                        alert(err.response.data.message)
                    } 
                    else {
                        alert(err)
                    }
                });
            },
            logout () {
                localStorage.setItem('authToken', '');
                
                config.stockbookApi('').post('/auth/logout')
                .then(result => {
                    this.$privateReactiveStore.setUser(null);
                })
                .catch(err => {
                    if (err.response.status >= 400) {
                        alert(err.response.data.message);
                    } 
                    else {
                        alert(err);
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    h1 {
        text-align: center;
    }
    .login-form {
        height: 50vh;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    v-input {
        margin-bottom: 3px;
    }
    .form-part {
        div {
            margin-bottom: 15px;
        }
        width: 300px;
            button {
              margin-top: 0;
            }
    }
</style>